const AdditionalCollection = () => (
    <div>
        <h3>Kolekcja akcesoriów i produktów...</h3>
    </div>
);

export default AdditionalCollection;
